





<template>
  <div>
    <v-layout wrap justify-center px-3 pt-lg-0 style="height:100vh">
      <v-flex xs12 sm6 lg5 align-self-center>
        <v-card>
          <v-layout wrap justify-center text-left py-5 pa-6>
            <v-flex xs12 text-center> </v-flex>
            <v-flex xs12>
              <v-card flat tile height="300px">
                <v-layout wrap justify-center fill-height text-center>
                  <v-flex xs12 align-self-center>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-img
                          height="150px"
                          contain
                          src="../../assets/Images/pending.svg"
                        >
                        </v-img>
                      </v-flex>
                      <v-flex xs12 pt-4>
                        <span
                          style="font-size: font-family:poppinsmedium; font-size: 12px; color: red"
                          >Please wait and refresh the page
                        </span>
                      </v-flex>
                      <v-flex xs12>
                        <span
                          style="font-size: 18px; color: black;font-family:poppinsmedium;"
                          >Verification Pending</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {};
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    getProfile() {
      axios({
        method: "post",
        url: "user/me",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            // this.$store.commit("loginUser", response.data.status);
            this.$store.commit("userData", response.data.data.sellerid);
            this.$store.commit("userDetailed", response.data);
            this.$store.commit("userCategory", response.data.data.sellerid.category[0]);
            this.$store.commit("userSubCategory", response.data.data.sellerid.subcategory);
            this.$store.commit("userType", response.data.data.role);
            // this.$store.commit("registrationStage", response.data.level);
            // this.$store.commit("profilestatus", response.data.profileStatus);
            if (response.data.profileStatus == "active") {
              this.$router.push("/Seller");
            }
            if (response.data.profileStatus == "reject") {
              this.$router.push("/sellerStatus");
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
